import { useState, useEffect, useCallback } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { toast } from 'react-toastify'


const useTemplatesViewModel = () => {
    
    const navigate = useNavigate()
    
    const [loading, setLoading] = useState(false)
    const [loadingCreateTemplate, setLoadingCreateTemplate] = useState(false)
    const [newTemplateType, setNewTemplateType] = useState('excel')
    const [newTemplateName, setNewTemplateName] = useState('')
    const [newTemplateFile, setNewTemplateFile] = useState('')
    const [pendingDeleteTemplate, setPendingDeleteTemplate] = useState(null)
    
    const organizations = useWireValue(store.organizations)
    const exportTemplates = useWireValue(store.exportTemplates)
    
    const {
        organization,
        organizationError,
        organizationIsLoading,
        fetchOrganization,
    } = useOutletContext()
    
    const templateName = `${organization.name} Export Template`
    
    const fetchExportTemplates = useCallback(async () => {
        
        try {
            setLoading(true)
            await actions.getExportTemplatesByOrgId(organization.id)
        } catch (e) {
            // @todo show error
            console.error('Export templates initial fetch', e)
            toast.error('Failed to fetch export runsheets templates')
        } finally {
            setLoading(false)
        }
        
    }, [organization])
    
    const onCreateTemplateClick = useCallback(async () => {
        
        setLoadingCreateTemplate(true)
        
        try {
            
            const res = await actions.createExportTemplate(
                organization.id,
                newTemplateType,
                newTemplateName,
                newTemplateFile,
            )
            
            await fetchExportTemplates()
            
            navigate(`/settings/orgs/${organization?.id}/templates/${res.id}`)
            
        } catch (e) {
            
            console.error('onCreateTemplateClick', e)
            toast.error('Failed to create export template')
            
        }
        
        setLoadingCreateTemplate(false)
        
    }, [organization, newTemplateType, newTemplateName, newTemplateFile])
    
    const onConfirmDeleteTemplateClick = useCallback(async () => {
        
        try {
            await actions.deleteExportTemplate(organization.id, pendingDeleteTemplate.id)
            await fetchExportTemplates()
            toast.success(`Deleted export template "${pendingDeleteTemplate.name}"`)
        } catch (e) {
            console.error('onConfirmDeleteTemplateClick', e)
            toast.error('Failed to delete export template')
        }
        
    }, [organization, pendingDeleteTemplate])
    
    useEffect(() => {
        
        if (organization)
            fetchExportTemplates()
        
    }, [organization])
    
    return {
        loading,
        loadingCreateTemplate,
        exportTemplates,
        newTemplateType,
        setNewTemplateType,
        newTemplateName,
        setNewTemplateName,
        newTemplateFile,
        setNewTemplateFile,
        pendingDeleteTemplate,
        setPendingDeleteTemplate,
        
        organizations,
        organization,
        organizationError,
        organizationIsLoading,
        fetchOrganization,
        
        templateName,
        
        onCreateTemplateClick,
        onConfirmDeleteTemplateClick,
    }
    
}

export default useTemplatesViewModel
